import { customScrollMinimal, TanStackTableRoot } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
`;

export const TableWrapper = styled.div`
  ${customScrollMinimal};
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow: auto;
`;

export const StyledTanStackTableRoot = styled(TanStackTableRoot)<{
  $isWatchlistPage: boolean;
}>`
  ${({ $isWatchlistPage }) =>
    !$isWatchlistPage &&
    css`
      table-layout: fixed;
    `}
`;

export const TickerCell = styled.div`
  display: flex;
  gap: 8px;
`;

export const Ticker = styled.div<{ $isWatchlistPage?: boolean }>`
  ${({ $isWatchlistPage }) =>
    $isWatchlistPage
      ? css`
          flex: 1;
          display: flex;
          align-items: center;
        `
      : css`
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        `}
`;

export const Name = styled.div<{ $isWatchlistPage?: boolean }>`
  ${({ $isWatchlistPage }) =>
    !$isWatchlistPage &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `}
`;

export const HighlightText = styled.span`
  color: var(--text-soft);

  b {
    font-family: var(--font-roboto-mono);
    color: var(--text-default);
  }
`;

export const CheckboxWrapper = styled.span`
  padding-left: 20px;
`;

export const StyledCol = styled.col<{ $percentageWidth: string }>`
  ${({ $percentageWidth }) =>
    css`
      width: ${$percentageWidth};
    `}
`;

export const DisabledLabel = styled.span<{ $isDisabled: boolean }>`
  color: ${({ $isDisabled }) =>
    $isDisabled ? 'var(--text-disabled)' : 'var(--text-default)'};
`;
